// extracted by mini-css-extract-plugin
export default {"kuraStorageDetailButton":"KuraStorage_kuraStorageDetailButton__WVZxa"};